var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, VModel } from 'vue-property-decorator';
import { ExternalDamageComponent } from '@declaration/components/externalDamage/ExternalDamageComponent';
import RadioImageButton from '@declaration/components/UI/RadioImageButton.vue';
import { VERANDA_PANELS_MATERIAL_CHOICES } from '@shared/constants/externalDamages/VerandaConstants';
import { VERANDA_PANELS_TITLE } from '@declaration/constants/externalDamages/VerandaConstants';
let VerandaPanelMaterials = class VerandaPanelMaterials extends ExternalDamageComponent {
    constructor() {
        super(...arguments);
        this.choices = VERANDA_PANELS_MATERIAL_CHOICES;
    }
    get title() {
        return this.translateExternalDamageKey(VERANDA_PANELS_TITLE);
    }
};
__decorate([
    VModel({ type: Array, default: () => [] })
], VerandaPanelMaterials.prototype, "materials", void 0);
VerandaPanelMaterials = __decorate([
    Component({ components: { RadioImageButton } })
], VerandaPanelMaterials);
export default VerandaPanelMaterials;
